import { safetyDetails } from "../../components/template/CustomTemplate/Pages/safetyDetails";
import CustomTemplates from "../WebPages/Deals/CustomTemplate";

const AddSafety = () => {
  return (
    <CustomTemplates
      page_type={"blog_item"}
      slug={"mobile-safety-and-guides"}
      attributes={safetyDetails}
    />
  );
};

export default AddSafety;
